<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Custom Pagination Styles */
.custom-pagination {
  margin: 20px 0 16px 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 4px !important;
}

.custom-pagination .v-pagination__item {
  min-width: 36px !important;
  height: 36px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #d0d0d0 !important;
  background: white !important;
  color: #424242 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  line-height: 1 !important;
  transform: none !important;
}

.custom-pagination .v-pagination__item:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
  border-color: #1976d2 !important;
  background: #f8f9fa !important;
  color: #1976d2 !important;
  transform: none !important;
}

.custom-pagination .v-pagination__item--is-active {
  background: #1976d2 !important;
  color: white !important;
  border-color: #1976d2 !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3) !important;
  transform: none !important;
}

.custom-pagination .v-pagination__item--is-active:hover {
  background: #1565c0 !important;
  color: white !important;
  box-shadow: 0 3px 10px rgba(25, 118, 210, 0.4) !important;
  transform: none !important;
}

.custom-pagination .v-pagination__prev,
.custom-pagination .v-pagination__next {
  border-radius: 6px !important;
  border: 1px solid #d0d0d0 !important;
  background: white !important;
  transition: all 0.2s ease !important;
  min-width: 36px !important;
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transform: none !important;
}

.custom-pagination .v-pagination__prev:hover,
.custom-pagination .v-pagination__next:hover {
  background: #f8f9fa !important;
  border-color: #1976d2 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
  transform: none !important;
}

.custom-pagination .v-pagination__prev .v-icon,
.custom-pagination .v-pagination__next .v-icon {
  color: #424242 !important;
  transition: color 0.2s ease !important;
}

.custom-pagination .v-pagination__prev:hover .v-icon,
.custom-pagination .v-pagination__next:hover .v-icon {
  color: #1976d2 !important;
}

/* Responsive */
@media (max-width: 600px) {
  .custom-pagination .v-pagination__item {
    min-width: 36px;
    height: 36px;
    font-size: 14px;
  }
  
  .custom-pagination {
    gap: 4px;
    margin: 16px 0;
  }
}

/* Vuetify Table Styles - Left align all table cells */
.v-data-table td {
  text-align: left !important;
}

.v-data-table th {
  text-align: left !important;
}

/* For simple tables */
.v-table td {
  text-align: left !important;
}

.v-table th {
  text-align: left !important;
}

/* For any table within the app */
table td {
  text-align: left !important;
}

table th {
  text-align: left !important;
}
</style>
